

// const frfr_lib_changes_id = '/FRFR/frfr-frontend-db.js/changes_id2022-12-14/';


/* 
FrFr FRIENDLY FRAMEWORK
frfr-json-utils
Version ID: 1a 2022-12-15r1
by 
// Please describe here if you customized this file
*/


const json_utils = {};

json_utils.is_json = function (raw) {
  // argument must be json string
  let valid = true;
  let decoded; // undefined
  try {
    decoded = JSON.parse(raw);
    console.log('CONFIRMED VALID JSON STRING :) string can be converted into JS with JSON.parse()');
  } catch (error) {
    valid = false;
    console.log('ERORR Invalid JSON string! - NOT JSON');
  }
  return valid;
};

json_utils.decode_if_json = function (raw) {
  // argument must be json string
  let valid = true;
  let decoded; // undefined
  try {
    decoded = JSON.parse(raw);
  } catch (error) {
    valid = false;
    // console.log('Invalid JSON string!');
  }
  return decoded;
};

json_utils.js_to_always_json = function (js) {
  // Argument is any js value, object, array, null, undefined etc... If undefined or anything in value is not comaptible with json, function will return json string with null.
  let valid = true;
  // let json = JSON.stringify(''); // if undefined
  let json = JSON.stringify(null); // if undefined
  try {
    json = JSON.stringify(js);
  } catch (error) {
    // json = JSON.stringify(''); // if undefined
    json = JSON.stringify(null); // if undefined
    valid = false;
    // console.log('Invalid JSON string!');
  }
  if (json) {
    return json;
  }
  // return '';
  // return 'null';
  return json;
};

export { json_utils };
// exports.json_utils = json_utils; // Node.js named export